module.exports = __webpack_public_path__ + "img/6C.cc24746a.jpg";